import { tKey } from 'ember-intl';
import {
  COLOR_SHORT_TERM_RENTAL_CLUSTER_LARGE,
  COLOR_SHORT_TERM_RENTAL_CLUSTER_MEDIUM,
  COLOR_SHORT_TERM_RENTAL_CLUSTER_SMALL,
  COLOR_SHORT_TERM_RENTAL_OTB,
  COLOR_SHORT_TERM_RENTAL_RATE,
  COLOR_TEXT_DEFAULT,
  COLOR_TEXT_INVERSE,
  getCssVariableString,
  getCssVariableValue,
} from 'frontend-utils/utils/css-variable';

export const SHORT_TERM_RENTAL = 'short_term_rental';

export const SHORT_TERM_RENTAL_DATEPICKER_MIN_DATE = '2023-01-01';

export const NUMBER_OF_HISTORICAL_DAYS = 120;
export const DEFAULT_NUMBER_OF_DAYS = 30;

// TODO Color constants are now using the current color scheme, needs to be updated when the color scheme changes
// Color discussion https://otainsight.slack.com/archives/C0461CHQ6QL/p1672914977075849
export const SHORT_TERM_RENTAL_OTB = getCssVariableString(
  COLOR_SHORT_TERM_RENTAL_OTB,
);
export const SHORT_TERM_RENTAL_RATE = getCssVariableString(
  COLOR_SHORT_TERM_RENTAL_RATE,
);

export const AL_REF_DAYS_AGO_VALUES = {
  yesterday: 1,
  threeDaysAgo: 3,
  sevenDaysAgo: 7,
  fourteenDaysAgo: 14,
};

export const MARKER_PROPS = {
  fillColor: 'transparent',
  strokeColor: getCssVariableValue('--prism-color-border-warning-emphasis'),
};

export const MAP_CLUSTER_SIZE = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
};

export const CLUSTER_PROPS = {
  widths: {
    small: 28,
    medium: 32,
    large: 36,
  },
  colors: {
    bg: {
      small: getCssVariableValue(COLOR_SHORT_TERM_RENTAL_CLUSTER_SMALL),
      medium: getCssVariableValue(COLOR_SHORT_TERM_RENTAL_CLUSTER_MEDIUM),
      large: getCssVariableValue(COLOR_SHORT_TERM_RENTAL_CLUSTER_LARGE),
    },
    text: {
      small: getCssVariableValue(COLOR_TEXT_DEFAULT),
      medium: getCssVariableValue(COLOR_TEXT_DEFAULT),
      large: getCssVariableValue(COLOR_TEXT_INVERSE),
    },
  },
  thresholds: {
    small: 20,
    medium: 150,
  },
};

export const LISTINGS = 'listings';
export const BEDS = 'beds';
export const OCCUPANCY = 'occupancy';
export const RATE = 'rate';

export const KPIS = [
  {
    CATEGORY: LISTINGS,
    FIRST_SUB_CATEGORY: 'short_term_rental.kpi.relevant',
    SECOND_SUB_CATEGORY: tKey('short_term_rental.kpi.total'),
  },
  {
    CATEGORY: BEDS,
    FIRST_SUB_CATEGORY: 'short_term_rental.kpi.relevant',
    SECOND_SUB_CATEGORY: tKey('short_term_rental.kpi.total'),
  },
  {
    CATEGORY: OCCUPANCY,
    FIRST_SUB_CATEGORY: 'short_term_rental.kpi.rentals',
    SECOND_SUB_CATEGORY: tKey('short_term_rental.kpi.my_hotel'),
  },
  {
    CATEGORY: RATE,
    FIRST_SUB_CATEGORY: 'short_term_rental.kpi.rentals',
    SECOND_SUB_CATEGORY: tKey('short_term_rental.kpi.my_hotel'),
  },
];

export const BREAKDOWN_TOOLTIP_TRANSLATIONS = {
  'pricing_type.static': tKey(
    'short_term_rental.tooltip.breakdowns.pricing_type_static',
  ),
  'pricing_type.dynamic': tKey(
    'short_term_rental.tooltip.breakdowns.pricing_type_dynamic',
  ),
};

export const TRIAL_ACTIONS = {
  START: 'start',
  GET_IN_TOUCH: 'get_in_touch',
  DISMISS: 'dismiss',
  NOT_NOW: 'not_now',
} as const;

export type TrialAction = (typeof TRIAL_ACTIONS)[keyof typeof TRIAL_ACTIONS];
